import React from "react";
import { useTranslation } from "react-i18next";
import { Popover } from "stories/components";

import { reportTooltipLines, sourceLabel } from "./fairValues";

// The fair value source of a summary row. With a report the label is a focusable tooltip
// target listing each portfolio's report: period, value date and received date.
const FairValueSource = ({ id, sources, reports }) => {
  const { t } = useTranslation();
  const label = sourceLabel(sources, t);
  const lines = reportTooltipLines(reports);
  if (lines.length === 0) {
    return <span>{label}</span>;
  }
  return (
    <span>
      <span id={id} tabIndex={0} className="portfolio-summary-fair-value__source">
        {label}
      </span>
      <Popover placement="top" target={id}>
        {lines.map((line, index) => (
          <div key={index} className="portfolio-summary-fair-value__report">
            <strong>{line.portfolio_name}</strong>
            <div>{t("fair_value_tooltip_period", "Jakso")}: {line.report_period}</div>
            <div>{t("fair_value_tooltip_value_date", "Arvopäivä")}: {line.value_date}</div>
            <div>{t("fair_value_tooltip_received", "Saapunut")}: {line.report_received}</div>
          </div>
        ))}
      </Popover>
    </span>
  );
};

export default FairValueSource;
